export default {
      id: "generate-insights-usage",
      viewBox: "0 0 76.332 37.22",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#generate-insights",
      toString: function () {
        return this.url;
      }
    }